// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f2Kbk","field":"styles_field__2Y2G4","fieldCol":"styles_fieldCol__pp2d2","diffCol":"styles_diffCol__WvEPr","diff":"styles_diff__87pyl"};